import { useState, forwardRef, useId } from "react";
import { FormControl, FormGroup } from "react-bootstrap";
import { FormLabel, FormFeedback } from "./utils";
// import DateTimePicker from "./DateTimePicker";
// import FormRange from "react-bootstrap/esm/FormRange";
import { EyeIcon, EyeOff } from "lucide-react";
import CommonDateRangePicker from "./CustomDateRange";

const InputField = forwardRef(
  (
    {
      icon = null,
      startIcon = false,
      className = "",
      sortable = false,
      coverClass = "",
      isHorizontal = false,
      onKeyDown,
      style = {},
      input = {},
      label = {},
      validation = {},
      iconWidth = 16,
      required = false,
      iconClass = "",
    },

    ref,
  ) => {
    const {
      placeholder = "",
      value = "",
      onChange = () => { },
      onBlur = () => { },
      readOnly = false,
      name = "",
      type = "text",
      step,
      className: inputClassName = "py-6",
      as,
      id: inputId,
      rows,

      ...restInput
    } = input || {};

    const {
      name: labelName = "",
      id: labelId,
      isHidden = false,
      class: labelClass = "",
    } = label || {};
    const {
      isInvalid = false,
      message: errorMessage = "",
      className: validationClass = "",
    } = validation || {};

    // ----------------------------------------------
    // ID Handling — robust & always valid
    // ----------------------------------------------
    const autoId = useId();
    const resolvedId = labelId || inputId || autoId;
    // ----------------------------------------------
    // Password toggle
    // ----------------------------------------------
    const [showPassword, setShowPassword] = useState(false);
    // const [showTimeDropdown, setShowTimeDropdown] = useState(false);
    // const [isTimeManualTyped, setIsTimeManualTyped] = useState(false);
    const isPasswordType = type === "password";
    const effectiveType = isPasswordType
      ? showPassword
        ? "text"
        : "password"
      : type;
    const isDateRange = type === "date-range";
    // ----------------------------------------------
    // Conditions
    // ----------------------------------------------
    const hasIcon = isPasswordType || icon || (type === "number" && sortable);

    return (
      <FormGroup
        className={`form-input-cover  ${isHorizontal
          ? `grid align-items-center ${isInvalid ? "mb-3" : ""}`
          : ""
          } ${className}`.trim()}
        style={style}
      >
        {/* Label */}

        <FormLabel
          className={`${isHorizontal ? "g-col-4 m-0" : ""} ${isHidden ? "visually-hidden" : ""
            } ${labelClass}`.trim()}
          id={resolvedId}
          labelName={labelName}
          required={required}
        />

        {/* INPUT + ICONS */}
        <div
          className={`${isHorizontal ? "g-col-8" : ""
            }  position-relative ${coverClass}  ${isInvalid && errorMessage ? "mb-3" : ""
            }`.trim()}
        >
          <div className={`position-relative ${type === "range" ? "d-flex align-items-center gap-4" : ""}`}>
            {
              isDateRange ? (<>
                <CommonDateRangePicker
                  value={value}
                  onChange={onChange}
                  name={name}
                  placeholder={placeholder}
                  className={`rounded-1 ${inputClassName} ${isInvalid ? "is-invalid" : ""}`.trim()}
                  {...restInput}
                />
              </>
              ) :
                type === "range" ? (<>
                  {/* <FormRange value={value ?? ""} onChange={onChange} step={step} name={name}  {...restInput} />
              <span className="fw-semibold text-success fs-sm">
                {value || 0}%
              </span> */}
                </>

                ) : (
                  <FormControl
                    ref={ref}
                    type={as === "textarea" ? undefined : effectiveType}
                    id={resolvedId}
                    name={name}
                    placeholder={placeholder}
                    readOnly={readOnly}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    onKeyDown={onKeyDown}
                    isInvalid={!!isInvalid}
                    aria-invalid={!!isInvalid}
                    step={type === "number" ? step || "any" : undefined}
                    autoComplete="off"
                    as={as}
                    rows={rows}
                    className={`rounded-2 ${inputClassName} ${(hasIcon && startIcon)
                      ? "start-icon"
                      : hasIcon
                        ? "end-icon"
                        : ""
                      } ${isInvalid ? "is-invalid" : ""}`.trim()}
                    {...restInput}
                  />
                )}

            {/* Password toggle */}
            {
              // isDateTimeLocal ? <i
              //   className={`ratio-1 flex-center position-absolute top-50 translate-middle-y end-0 me-6 ${iconClass}`}
              //   style={{ width: iconWidth }}
              //   aria-label={"Select Date and Time"}
              // >
              //   <Calendar size={iconWidth} />
              // </i> : 
              isPasswordType ? (
                <button
                  type="button"
                  className={`lh-1 position-absolute top-50 translate-middle-y end-0 me-2 cursor-pointer text-primary password-btn`}
                  onClick={() => setShowPassword((s) => !s)}
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      setShowPassword((s) => !s);
                    }
                  }}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? (
                    <EyeOff size={18} />
                  ) : (
                    <EyeIcon size={18} />
                  )}
                </button>
              )
                //  : type === "search" ? (
                //   <>
                //     <i
                //       className={`ratio-1 flex-center position-absolute top-50 translate-middle-y start-0 ms-6 ${iconClass}`}
                //       style={{ width: iconWidth }}
                //     >
                //       <SearchIcon size={iconWidth} />
                //     </i>
                //   </>
                // )
                : (
                  <>
                    {/* Custom icon */}
                    {icon && (
                      <i
                        className={`ratio-1 flex-center position-absolute top-50 translate-middle-y  ${startIcon ? "start-0 ms-6" : "end-0 me-6"
                          }`}
                        style={{ width: iconWidth }}
                      >
                        {icon}
                      </i>
                    )}
                  </>
                )}
          </div>
          {/* ERROR MESSAGE */}
          {isInvalid && errorMessage && (
            <FormFeedback
              className={`position-absolute top-100 ${validationClass}`}
              message={errorMessage}
            />
          )}
        </div>
      </FormGroup>
    );
  },
);

InputField.displayName = "InputField";
export default InputField;
